import { ISetRedux2 } from "../interfaces/ISeleccion";

export const useChangeStatus = (props: ISetRedux2) => {
  const { dispatch, payload, type } = props;
  dispatch({
    type,
    payload,
  });
};
